import V from "gcl";
import C from "vesh";
import Q from "querystring";

/**
 * ES库表转换器
 * https://www.elastic.co/guide/en/elasticsearch/client/javascript-api/current/api-reference.html
 * >
 * >=
 * <
 * <=
 * =
 * !=
 * ~= in
 * !~= not in
 * @= find_in_set
 * !@= not find_in_set
 * %= like
 * !%= not like
 * && and 嵌套
 * || or 嵌套
 */
export const EMBESConverter = class {
  constructor() {
    const { _, __ } = pri(this, {
      opes: {},
      getValue: (v) =>
        undefined === v || undefined === v.value
          ? undefined
          : (v.value !== null ? v.value + "" : "").replace(/;/g, "_").trim(),
      getKValue: (k, v) => {
        // console.log('query:2 ',k,v,k.startsWith('?') || k.startsWith('_'));
        if (k.startsWith("?") || k.startsWith("_")) {
          if (undefined === __.getValue(v[k.trim("?")]))
            throw new Error(k + "参数要求为必填!");
          return `'${__.getValue(v[k.trim("?")])}'`;
        } else return k;
      },
      tindex: "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z".split(","),
      jopes: {
        "+": "inner join",
        ">+": "left join",
        "<+": "right join",
        ",": ",",
      },
      getTable(database, table, params) {
        // var opes = table.match(/[<>]?\+|\,/g);
        if (table.match(/\|/g)) return "{tablename}";
        else return `${table}${!!params["_as"] ? " as a " : ""}`;
      },
      idic: {
        ">": "gt",
        "<": "lt",
        ">=": "gte",
        "<=": "lte",
      },
    });
    ">,>=,=,<=,<,!=,~=,!~=,@,!@,@=,!@=,%=,!%=,&&,||,+,("
      .split(",")
      .forEach((v) => (__.opes[v] = true));
  }

  getWhere(params, onlywhere = false) {
    const { __ } = pri(this);
    const paraname = {};
    for (var i in params)
      if (params[i] !== undefined && params[i].value !== undefined)
        paraname[i.toLowerCase()] = params[i];
    /**
     * 需要判断
     * _and
     * _or
     * _count
     * _order
     * _group
     * _page
     * todo or 和 and 不全 缺少对~/* /* /或者~/* /的辅助
     */
    let sb = V.sb();
    try {
      sb.append(this.getOpe(params, "and"));
      if (!V.isValid(sb.toString())) sb.append(" 1=1 ");
      if (!onlywhere) {
        if (__.getValue(paraname["_group"]))
          sb.append(` group by ${__.getValue(paraname["_group"])} `);
        if (__.getValue(paraname["_order"]))
          sb.append(` order by ${__.getValue(paraname["_order"])} `);
        if (__.getValue(paraname["_orderby"]))
          sb.append(` order by ${__.getValue(paraname["_orderby"])} `);
        if (__.getValue(paraname["_limit"])) {
          sb.append(
            ` limit ${__.getValue(paraname["_limit"]).replace(/\s/g, "")} `,
          );
          params["_start"] = 0;
          params["_size"] = +__.getValue(paraname["_limit"]).replace(/\s/g, "");
        } else if (__.getValue(paraname["_page"])) {
          var pages = __.getValue(paraname["_page"])
            .replace(/\s/g, "")
            .split(",");
          params["_start"] = pages[0];
          params["_size"] = +pages[0] + +(pages[1] || 0);
          sb.append(` limit ${params["_size"]} `);
        }
      } else if (
        onlywhere === 2 &&
        (__.getValue(paraname["_page"]) || __.getValue(paraname["_limit"]))
      ) {
        var size = +(
          __.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])
        ).replace(/\s/g, "");
        sb.append(` limit ${size} `);

        params["_start"] = 0;
        params["_size"] = size;
      } else {
        if (__.getValue(paraname["_page"])) {
          var pages = __.getValue(paraname["_page"])
            .replace(/\s/g, "")
            .split(",");
          params["_start"] = pages[0];
          params["_size"] = +pages[0] + +(pages[1] || 0);
        }
      }
      return sb.clear();
    } finally {
      sb = null;
    }
  }

  /**
   * @test name (a,b)=>11
   * @test name (a,b)=>11
   * @param {*} params
   * @param {*} split
   */
  getOpe(params, split) {
    const { _, __ } = pri(this);
    let sb = V.sb();
    try {
      for (let k in params) {
        if (
          params[k] === undefined ||
          (params[k].isStandard !== undefined && params[k].value === undefined)
        ) {
          delete params[k];
          continue;
        }
        k = k.trim();
        if (
          k.startsWith("_") ||
          (!k.eq("+") && !k.eq("&&") && !k.eq("||") && !k.startsWith("$"))
        )
          continue;

        let v = __.getValue(params[k]);

        // let _v = params[k.trim("$")];
        //计算列替换

        // if (_v && (__.getValue(_v) + "").match(/[`(?"'\.\+\-*\/]/g))
        //   k = __.getValue(_v);

        if (
          typeof v == "string" &&
          v.indexOf("?_NULL") >= 0 &&
          !params["_NULL"]
        ) {
          params["_NULL"] = { value: null, isStandard: true };
        }
        //有问题
        //if (!params[k.substr(1)]) params[k.substr(1)] = params[k];
        delete params[k];
        if (undefined === v) continue;
        let i = 3;
        if (
          __.opes[k] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.substr(0, i--)]
        ) {
          let ope = i == 3 ? k : v.substr(0, i + 1).toLowerCase();
          k = k.trim("$");
          // k = k.substr(1);
          switch (ope) {
            case "(":
              sb.append(` ${v} `);
              break;
            case "+":
              //为on 特别准备 如果没有删除 那么说应需要在where中出现
              let options = eval(`[${params[ope]}]`)[0];
              options.forEach(function (v, i) {
                sb.append(_.getOpe(v, "and"));
              });
              break;
            case ">":
            case ">=":
            case "<":
            case "<=":
            case "!=":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : !!k.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                      ? k
                      : '"' + k + '"'
                } ${ope}`,
              );
              //k.match(/\./) ||  v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/))
              if (
                !v.startsWith("'") &&
                !v.startsWith('"') &&
                !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
              ) {
                // console.log(136,v.substr(ope.length),__.getKValue(v.substr(ope.length),params));
                //select DelFlag,count("ID") as ID from bt_5030b820a1ac4a55b6a2f0cba2c3bbe9 where  "DelFlag" !=!=1 and  ProjectID = '70557288787779584' and  ( ( "DelFlag" !=!=4 and  "DeadLine" <=now() ) or  ( DelFlag = '4' and  "DeadLine" >=>=FinishTime ) ) group by DelFlag
                //select Operator,count("ID") as ID from bt_5030b820a1ac4a55b6a2f0cba2c3bbe9 where  "DelFlag" !=!=1 and  ProjectID = '70557288787779584' group by Operator
                //console.log('query:',v.substr(ope.length),params,__.getKValue(v.substr(ope.length),params));
                sb.append(__.getKValue(v.substr(ope.length), params));
              } else if (params[k] || v.indexOf("`") >= 0)
                sb.append(
                  `${
                    v.indexOf("`") < 0
                      ? `'${v.substr(ope.length).trim('"').trim("'")}'`
                      : v.substr(ope.length)
                  }`,
                );
              else {
                k = "_" + k.replace(/\./g, "_") + V.random();
                // sb.append(`?${k}`);
                sb.append(
                  "undefined".eq(v) || v.length == 0
                    ? "''"
                    : v.substr(ope.length).trim('"').trim("'"),
                );
                // (params[k] = { value: __.getKValue(v.substr(ope.length),params).trim('"').trim('\''), isStandard: true });
              }
              break;
            default:
              sb.append(
                ` ${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? "ifnull(" + k + ",'')" : k} `,
              );
              if ("?_NULL".eq(v)) {
                sb.append("is NULL");
              } else {
                sb.append(`${ope} `);
                //k.match(/\./) ||

                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  sb.append(__.getKValue(v.substr(ope.length), params));
                else if (params[k] || v.indexOf("`") >= 0)
                  sb.append(
                    `${
                      v.indexOf("`") < 0
                        ? `'${v.substr(ope.length).trim('"').trim("'")}'`
                        : v.substr(ope.length)
                    }`,
                  );
                else {
                  k = "_" + k.replace(/\./g, "_") + V.random();
                  // sb.append(`?${k}`);
                  v = v.trim('"').trim("'");
                  sb.append(
                    "undefined".eq(v) || v.length == 0 ? "''" : `'${v}'`,
                  );
                  // (params[k] = { value: __.getKValue(v.substr(ope.length),params).trim('"').trim('\''), isStandard: true });
                }
              }
              break;
            case "~=":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : k.indexOf(".") >= 0
                      ? k
                      : '"' + k + '"'
                } in (`,
              )
                .append(
                  v
                    .substr(2)
                    .replace(/[\(\)]/g, "")
                    .split(",")
                    .map((v2) =>
                      v2.match(/[`?"'\.\+\-*\/\(\)]/g) ? v2 : `'${v2}'`,
                    )
                    .join(","),
                )
                .append(")");
              break;
            case "!~=":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : k.indexOf(".") >= 0
                      ? k
                      : '"' + k + '"'
                } not in (`,
              )
                .append(
                  v
                    .substr(3)
                    .replace(/[\(\)]/g, "")
                    .split(",")
                    .map((v2) =>
                      v2.match(/[`?"'\.\+\-*\/\(\)]/g) ? v2 : `'${v2}'`,
                    )
                    .join(","),
                )
                .append(")");
              break;
            case "@":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : k.indexOf(".") >= 0
                      ? k
                      : '"' + k + '"'
                } between ${v
                  .substr(1)
                  .replace(/[\(\)]/g, "")
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2.trim('"').trim("'").trim("`")
                      : `'${v2}'`,
                  )
                  .join(" and ")} `,
              );
              break;
            case "!@":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : k.indexOf(".") >= 0
                      ? k
                      : '"' + k + '"'
                } not between ${v
                  .substr(2)
                  .replace(/[\(\)]/g, "")
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2.trim('"').trim("'").trim("`")
                      : `'${v2}'`,
                  )
                  .join(" and ")} `,
              );
              break;
            case "@=":
              sb.append(
                ` find_in_set(${
                  (v.endWith("`") ? "" : '"') +
                  v.substr(2).replace(/['"]/g, '"') +
                  (v.endWith("`") ? "" : '"')
                },${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"})>0`,
              );
              break;
            case "!@=":
              sb.append(
                ` find_in_set(${
                  (v.endWith("`") ? "" : '"') +
                  v.substr(3).replace(/['"]/g, '"') +
                  (v.endWith("`") ? "" : '"')
                },${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"})<=0`,
              );
              break;
            case "%=":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : k.indexOf(".") >= 0
                      ? k
                      : '"' + k + '"'
                } like '%${v
                  .substr(2)
                  .trim("'")
                  .trim('"')
                  .replace(/'/g, "\\'")}%'`,
              );
              break;
            case "!%=":
              sb.append(
                ` ${
                  k.startsWith("?")
                    ? __.getValue(params[k.trim("?")])
                    : k.indexOf(".") >= 0
                      ? k
                      : '"' + k + '"'
                } not like '%${v
                  .substr(3)
                  .trim("'")
                  .trim('"')
                  .replace(/'/g, "\\'")}%'`,
              );
              break;
            case "&&":
              {
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                sb.append(" (");
                opes.forEach(function (v, i) {
                  sb.append(_.getOpe(v, "and"));
                  for (let k2 in v) {
                    if (k2.startsWith("_")) params[k2] = v[k2];
                    //参数设定补偿
                  }
                  if (i < opes.length - 1) sb.append(" and ");
                });
                sb.append(" )");
                //保证适配性更好
              }
              break;
            case "||":
              {
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                sb.append(" (");
                opes.forEach(function (v, i) {
                  sb.append(_.getOpe(v, "or"));
                  for (let k2 in v) {
                    if (k2.startsWith("_")) params[k2] = v[k2];
                    //参数设定补偿
                  }
                  if (i < opes.length - 1) sb.append(" or ");
                });
                sb.append(" )");
                //保证适配性更好
              }
              break;
          }
        } else {
          k = k.trim("$");
          // k = k.substr(1);

          sb.append(
            ` ${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? "ifnull(" + k + ",'')" : k} `,
          );

          if ("?_NULL".eq(v)) {
            sb.append(" is NULL");
          } else {
            sb.append("= ");

            //k.match(/\./) ||
            if (
              !v.startsWith("'") &&
              !v.startsWith('"') &&
              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
            )
              sb.append(__.getKValue(v, params));
            else if (params[k] || v.indexOf("`") >= 0)
              sb.append(v.indexOf("`") < 0 ? `'${v.trim("'").trim('"')}'` : v);
            else {
              k = "_" + k.replace(/[\.\?\$\(\)]/g, "_") + V.random();
              // sb.append(`?${k}`);
              v = v.trim('"').trim("'");
              sb.append("undefined".eq(v) || v.length == 0 ? "''" : `'${v}'`);
            }
            // sb.append(',\'\')');
          }
        }
        sb.append(` ${split} `);
      }
      return sb.clear().trim(` ${split} `);
    } finally {
      sb = null;
    }
  }

  /**
     * 
                    if((''+v).startsWith('?')) {
                        if (params[v.trim('?')]===undefined || params[v.trim('?')].value===undefined) {
                            if('?_NULL'.eq(v)) v=null;
                            else if('?_GUID'.eq(v)) v=V.GUID();
                            else if('?_SNOW'.eq(v)) v=V.SNOWID();
                            else throw new Error(v+'要求为必填!');
                        } else
                            v = __.getValue(params[v.trim('?')]);
                    }
     * @param {*} params 
     * @param {*} onlywhere 
     * @param {*} body 
     */

  getESWhere(params, onlywhere = false, body) {
    const { __ } = pri(this);
    const paraname = {};
    for (var i in params)
      if (params[i] !== undefined && params[i].value !== undefined)
        paraname[i.toLowerCase()] = params[i];

    /**
     * 需要判断
     * _and
     * _or
     * _count
     * _order
     * _group
     * _page
     * todo or 和 and 不全 缺少对~/* /* /或者~/* /的辅助
     */
    var query = { bool: {} };
    try {
      this.getESOpe(query.bool, params, false);
      // if (!V.isValid(sb.toString())) sb.append('  ');

      //{"query":{"term":{"CategoryIDs":619}},"sort":[{"OrderType":"desc"}]}
      if (!onlywhere) {
        if (__.getValue(paraname["_group"])) delete paraname["_group"];
        //sb.append(` group by ${__.getValue(paraname['_group'])} `)
        if (
          __.getValue(paraname["_order"]) ||
          __.getValue(paraname["_orderby"])
        ) {
          var order = (
            __.getValue(paraname["_order"]) || __.getValue(paraname["_orderby"])
          ).split(",");
          body["sort"] = order.map(function (v) {
            v = v.split(" ");
            return { [v[0]]: v[1] || "asc" };
          });
          delete params["_order"];
          delete params["_orderby"];
        }

        //{"query":{"term":{"CategoryIDs":619}},"from":1,"size":1,"sort":[{"OrderType":"desc"}]}
        if (__.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])) {
          var pages = (
            __.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])
          ).split(",");
          body["size"] = pages.pop();
          body["from"] = pages.length > 2 ? pages[0] : 0;
          delete params["_page"];
          delete params["_limit"];
        }
      } else if (
        onlywhere === 2 &&
        (__.getValue(paraname["_page"]) || __.getValue(paraname["_limit"]))
      ) {
        if (__.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])) {
          var pages = (
            __.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])
          ).split(",");
          body["size"] = pages.pop();
          body["from"] = pages.length > 2 ? pages[0] : 0;
          delete params["_page"];
          delete params["_limit"];
        }
      }
      return query;
    } finally {
    }
  }

  /**
   * https://www.knowledgedict.com/tutorial/elasticsearch-query-bool.html
   * @test name (a,b)=>11
   * @test name (a,b)=>11 todo
   * @param {*} params
   * @param {*} split
   */
  getESOpe(data, params, isNot) {
    const { _, __ } = pri(this);
    let sb = V.sb();
    try {
      for (let k in params) {
        if (
          params[k] === undefined ||
          (params[k].isStandard !== undefined && params[k].value === undefined)
        ) {
          delete params[k];
          continue;
        }
        k = k.trim();
        if (
          k.startsWith("_") ||
          (!k.eq("+") && !k.eq("&&") && !k.eq("||") && !k.startsWith("$"))
        )
          continue;

        let v = __.getValue(params[k]);

        // let _v = params[k.trim("$")];
        //计算列替换

        // if (_v && (__.getValue(_v) + "").match(/[`(?"'\.\+\-*\/]/g))
        //   k = __.getValue(_v);

        //有问题
        //if (!params[k.substr(1)]) params[k.substr(1)] = params[k];
        delete params[k];
        if (undefined === v) continue;
        let i = 3,
          _data = {};
        if (
          __.opes[k] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.substr(0, i--)]
        ) {
          let ope = i == 3 ? k : v.substr(0, i + 1).toLowerCase();
          k = k.trim("$");
          // k = k.substr(1);
          // if(data['bool']){
          //     _.getESOpe(data['bool'],{['$'+k]:v},false);
          //     continue;
          // }
          switch (ope) {
            case "(":
              //todo
              data[k] = v;
              break;
            case ">":
            case ">=":
            case "<":
            case "<=":
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                k = k.match(/[`?"'\.\+\-*\/\(\)]/g) ? params[k.trim("?")] : k;
                _data["range"] = _data["range"] || {};
                _data["range"][k] = _data["range"][k] || {};

                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  v = __.getKValue(v.substr(ope.length), params);
                else if (params[k] || v.indexOf("`") >= 0)
                  v =
                    v.indexOf("`") < 0
                      ? v.substr(ope.length).trim('"').trim("'")
                      : v.substr(ope.length);
                else {
                  v = v.substr(ope.length).trim('"').trim("'");
                }
                _data["range"][k][__.idic[ope]] = ("" + v).trim('"').trim("'");
              }
              break;
            default:
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                k = k.match(/[`?"'\.\+\-*\/\(\)]/g) ? params[k.trim("?")] : k;
                if ("?_NULL".eq(v)) {
                  _data["missing"] = _data["missing"] || { fields: [] };
                  _data["missing"]["fields"].push(k);
                } else {
                  _data[ope] = params[ope] || {};
                  _data[ope][k] = v.trim('"').trim("'");
                }
              }
              break;
            case "@=":
            case "~=":
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                k = k.match(/[`?"'\.\+\-*\/\(\)]/g) ? params[k.trim("?")] : k;
                _data["terms"] = _data["terms"] || {};
                _data["terms"][k] = v
                  .substr(2)
                  .replace(/[\(\)]/g, "")
                  .split(",")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2
                      : v2,
                  );
              }
              break;
            case "%=":
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                k = k.match(/[`?"'\.\+\-*\/\(\)]/g) ? params[k.trim("?")] : k;
                _data["match"] = _data["match"] || {};

                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  v = v.substr(ope.length);
                else if (params[k] || v.indexOf("`") >= 0)
                  v =
                    v.indexOf("`") < 0
                      ? v.substr(ope.length).trim('"').trim("'")
                      : v.substr(ope.length).trim('"').trim("'");
                else {
                  v = v.substr(ope.length).trim('"').trim("'");
                }

                _data["match"][k] = v;
              }
              break;
            case "!~=":
            case "!%=":
            case "!=":
            case "!@=":
              {
                var val = {};
                _.getESOpe(
                  val,
                  {
                    ["$" + k]:
                      ope.length > 2
                        ? v.substr(1).trim('"').trim("'")
                        : {
                            value: v.substr(2).trim('"').trim("'"),
                            isStandard: true,
                          },
                  },
                  true,
                );
                V.merge(_data, val["must"][0], true);
                // console.log(data['bool']['must_not'],ope,{['$'+k]:ope.length>2?v.substr(1).trim('"').trim("'"):{value:v.substr(2).trim('"').trim("'"),isStandard:true}});
              }
              break;
            case "@":
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                k = k.match(/[`?"'\.\+\-*\/\(\)]/g) ? params[k.trim("?")] : k;
                _data["range"] = _data["range"] || {};
                _data["range"][k] = _data["range"][k] || {};

                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  v = v.substr(ope.length);
                else if (params[k] || v.indexOf("`") >= 0)
                  v =
                    v.indexOf("`") < 0
                      ? v.substr(ope.length).trim('"').trim("'")
                      : v.substr(ope.length);
                else {
                  v = v.substr(ope.length).trim('"').trim("'");
                }

                v = v
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2
                      : `"${v2}"`,
                  );
                _data["range"][k] = {
                  gte: v[0].trim('"').trim("'"),
                  lte: v[1].trim('"').trim("'"),
                };
              }
              break;
            case "!@":
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                k = k.match(/[`?"'\.\+\-*\/\(\)]/g) ? params[k.trim("?")] : k;
                _data["range"] = _data["range"] || {};
                _data["range"][k] = _data["range"][k] || {};

                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  v = v.substr(ope.length);
                else if (params[k] || v.indexOf("`") >= 0)
                  v =
                    v.indexOf("`") < 0
                      ? v.substr(ope.length).trim('"').trim("'")
                      : v.substr(ope.length);
                else {
                  v = v.substr(ope.length).trim('"').trim("'");
                }
                v = v
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2
                      : `"${v2}"`,
                  );
                _data["range"][k] = {
                  gte: v[1].trim('"').trim("'"),
                  lte: v[0].trim('"').trim("'"),
                };
              }
              break;
            case "&&":
              {
                // “bool”: {
                //     “must”: { “match”: {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                _data["bool"] = _data["bool"] || { must: {} };
                opes.forEach(function (v, i) {
                  _.getESOpe(_data["bool"]["must"], v, false);
                });
                //保证适配性更好
              }
              break;
            case "||":
              {
                data["must"] = data["must"] || [];
                data["must"].push(_data);
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                _data["bool"] = _data["bool"] || { should: {} };
                opes.forEach(function (v, i) {
                  _.getESOpe(_data["bool"]["should"], v, false);
                });
              }
              break;
          }
        } else {
          k = k.trim("$");
          // k = k.substr(1);

          if ("?_NULL".eq(v)) {
            //tocheck fields / field
            data["must"] = data["must"] || [];
            data["must"].push(_data);

            if (isNot) {
              //意思相反
              _data["exists"] = _data["exists"] || { fields: [] };
              _data["exists"]["fields"].push(k);
            } else {
              _data["missing"] = _data["missing"] || { fields: [] };
              _data["missing"]["fields"].push(k);
            }
          } else {
            data["must"] = data["must"] || [];
            data["must"].push(_data);
            _data["term"] = { [k]: v.trim('"').trim("'") };
          }
        }
        // sb.append(` ${split} `);
      }
      return sb.clear();
    } finally {
      sb = null;
    }
  }

  lstParams(params, func, split = ",") {
    let sb = V.sb();
    try {
      for (let k in params) {
        let v = params[k];
        !k.startsWith("_") &&
          !k.startsWith("$") &&
          k.indexOf(";") < 0 &&
          typeof v != "function" &&
          sb.append(func(k, v)).append(split);
      }
      return sb.clear().trim(split);
    } finally {
      sb = null;
    }
  }

  convert(cmd) {
    const { _, __ } = pri(this, {
      Type2: {
        varchar: "keyword",
        string: "keyword",
        int: "integer",
        int16: "short",
        int32: "integer",
        int64: "long",
        long: "long",
        double: "double",
        float: "float",
        text: "text",
        date: "date",
        datetime: "date",
        nanos: "date_nanos", //纳秒
        boolean: "boolean",
        binary: "binary",
        //text, keyword,long, integer, short, byte, double, float, half_float, scaled_float,date,date_nanos,boolean,binary,integer_range, float_range, long_range, double_range, date_range
      },
    });
    var that = this;
    let command = cmd.command || "",
      params = cmd.params,
      paraname = {};
    for (var i in params) {
      //防止注入
      if (!!i.match(/;/)) delete params[i];
      else paraname[i.toLowerCase()] = params[i];
    }
    const cmds = command.replace(/[\\\/]/g, ".").split(".");
    const es = {};

    let sb = V.sb();
    //const ID = params._ID || params._IID; //_IID:自增AutoIncrease ID
    try {
      switch (cmds.length) {
        case 4:
          {
            /**
             * id 主键
             * column 修改表
             * index 索引
             * add
             * drop
             */
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              table = cmds[1],
              obj = cmds[2].toLowerCase(),
              method = cmds[3];
            if ("column".eq(obj))
              switch (method.toLowerCase()) {
                case "add":
                  {
                    params._method = "indices";
                    es.index = table;
                    sb.append("putMapping");
                    es["body"] = { properties: {} };
                    that.lstParams(params, (k, v) => {
                      var _type = (__.getValue(v) || "text").toLowerCase();
                      es["body"]["properties"][k] = {
                        type: __.Type2[_type] || _type,
                      };
                    });
                  }
                  break;
                case "change":
                case "drop":
                default:
                  throw new Error("未识别的命令" + command);
              }
            else throw new Error("不支持的修改类型!");
          }
          break;
        case 3:
          /**
           * 库名/表名/操作
           * create 建表
           * drop 删除表
           * add 增加数据
           * del 删除数据
           * update 修改数据? 同名字段
           * select 查询数据
           * count 查询数据
           * sum 查询数据
           * edit 指明select,count,sum之外的操作
           * truncate
           * reindex
           * rename
           * //create:添加一条记录,get:根据ID查询,deleteById：根据ID删除，search:搜索,index：根据ID覆盖更新 query
           */
          {
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              table = cmds[1],
              method = cmds[2];

            params._method = method;
            params._table = table;
            switch (method.toLowerCase()) {
              case "reindex":
                {
                  params._method = "reindex";
                  // es.index = table;
                  sb.append("");
                  if (!params["_dest"])
                    throw new Error("请输入复制到的索引名_dest");
                  es["body"] = {
                    source: { index: table },
                    dest: { index: __.getValue(params["_dest"]) },
                  };
                  if (__.getValue(params["_source"])) {
                    //console.log(4444,params['_source']);
                    es["body"].source["_source"] =
                      params["_source"].value.split(",");
                  }
                  es["refresh"] = true;
                }
                break;
              case "rename":
                {
                  params._method = "indices";
                  // es.index = table;
                  sb.append("updateAliases");
                  if (!params["_dest"])
                    throw new Error("请输入要修改的索引名_dest");
                  es["body"] = {
                    actions: {
                      add: {
                        index: table,
                        alias: __.getValue(params["_dest"]),
                      },
                    },
                  };
                  //很可能是 es['action']
                  //es['refresh'] = true;
                }
                break;
              case "dename":
                {
                  params._method = "indices";
                  // es.index = table;
                  sb.append("updateAliases");
                  if (!params["_dest"])
                    throw new Error("请输入要修改的索引名_dest");
                  es["body"] = {
                    actions: {
                      remove: {
                        index: table,
                        alias: __.getValue(params["_dest"]),
                      },
                    },
                  };
                  //很可能是 es['action']
                  //es['refresh'] = true;
                }
                break;
              case "setting":
                {
                  params._method = "index";
                  es.index = table;
                  sb.append("putSettings");
                  es["body"] = {};
                  that.lstParams(params, (k, v) => {
                    es["body"][k] = __.getValue(v);
                  });
                }
                break;

              case "createview":
                throw new Error("ES不支持此操作!");
                break;
              case "dropview":
                throw new Error("ES不支持此操作!");
                break;
              case "create":
                {
                  params._method = "indices";
                  es.index = table;
                  sb.append("create");
                  es["settings"] = V.merge(
                    {
                      number_of_shards: 2,
                      number_of_replicas: 2,
                    },
                    __.getValue("_settings")
                      ? V.json(__.getValue(params["_settings"]) || "{}")
                      : {},
                  );
                  es["mappings"] = { properties: {} };
                  that.lstParams(params, (k, v) => {
                    if (k.indexOf("_") == 0) return;
                    var _type = (__.getValue(v) || "text").toLowerCase();
                    es["mappings"]["properties"][k] = {
                      type: __.Type2[_type] || _type,
                    };
                    if (v.fielddata)
                      es["mappings"]["properties"][k]["fielddata"] = true;
                  });
                }
                break;
              case "drop":
                {
                  params._method = "indices";
                  es.index = table;
                  sb.append("delete");
                }
                break;
              case "replace":
              case "add":
                {
                  params._method = "index";
                  es.index = table;
                  es.id = params["ID"] && params["ID"].value;
                  es["body"] = {};
                  //insert into a (a,b,c) values (?a,?b,?c);select @@IDentity as ID,row_count as count;
                  that.lstParams(params, (k, v) => {
                    var val =
                      v && v.value === null ? "_NULL" : __.getValue(v) || "";

                    if (val.indexOf("?_GUID") >= 0) {
                      params["_GUID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.GUID(),
                      };
                      es["body"][k] = params["_GUID"].value;
                      es.id = params["_GUID"].value;
                      return;
                    }

                    if ("?_SNOWID".eq(val)) {
                      params["_SNOWID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.SNOWID(),
                      };
                      es["body"][k] = params["_SNOWID"].value;
                      es.id = params["_SNOWID"].value;
                      return;
                    }

                    if (val.indexOf("?_NULL") >= 0 || "_NULL".eq(val)) {
                      params["_NULL"] = {
                        type: "varchar",
                        isStandard: true,
                        value: null,
                      };
                      es["body"][k] = null;
                      return;
                    }
                    if (
                      !val.startsWith("'") &&
                      !val.startsWith('"') &&
                      !!val.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                    )
                      es["body"][k] = __.getKValue(
                        val.trim('"').trim("'"),
                        params,
                      );
                    else {
                      es["body"][k] = __.getKValue(
                        val.trim('"').trim("'"),
                        params,
                      );
                    }
                  });
                }

                break;
              case "drop":
              case "del":
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select row_count() as count;
                {
                  params._method = "deleteByQuery";
                  es.index = table;
                  sb.append("");
                  es.body = {};
                  es.body["query"] = that.getESWhere(params, true, es.body);
                  if (
                    !es.body.query ||
                    V.toJsonString(es.body.query).length <= 2
                  ) {
                    console.log(V.toJsonString(es));
                    throw new Error("不能无条件删除所有数据!");
                  }
                }
                break;
              case "truncate":
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select row_count() as count;
                {
                  params._method = "deleteByQuery";
                  es.index = table;
                  es.body = {};
                  es.body["query"] = that.getESWhere(
                    { $ID: "!=" },
                    true,
                    es.body,
                  );
                  sb.append("");
                }
                break;
              case "update":
                {
                  params._method = "updateByQuery";
                  es.index = table;
                  sb.append("");
                  es.body = {};
                  es.body["query"] = that.getESWhere(params, true, es.body);
                  es.body["script"] = {};
                  if (
                    !es.body.query ||
                    V.toJsonString(es.body.query).length <= 2
                  ) {
                    console.log(V.toJsonString(es));
                    throw new Error("不能无条件更新所有数据!");
                  }

                  //insert into a (a,b,c) values (?a,?b,?c);select @@IDentity as ID,row_count as count;
                  var opes = {};
                  that.lstParams(params, (k, v) => {
                    var val =
                      v && v.value === null ? "_NULL" : __.getValue(v) || "";
                    console.log(
                      1239,
                      params["CreditNo"],
                      k,
                      val,
                      "?_NULL".eq(val) || "_NULL".eq(val),
                    );
                    if (val.indexOf("?_GUID") >= 0) {
                      params["_GUID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.GUID(),
                      };
                      opes[k] = '"' + params["_GUID"].value + '"';
                      return;
                    }

                    if ("?_SNOWID".eq(val)) {
                      params["_SNOWID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.SNOWID(),
                      };
                      opes[k] = params["_SNOWID"].value;
                      return;
                    }

                    if ("?_NULL".eq(val) || "_NULL".eq(val)) {
                      params["_NULL"] = {
                        type: "varchar",
                        isStandard: true,
                        value: null,
                      };
                      opes[k] = null;
                      return;
                    }
                    // if (!val.startsWith('\'') && !val.startsWith('"') && !!val.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)) opes[k] = val; else {
                    //     opes[k] = '"'+val.trim('"').trim('\'').trim('`').replace(/\"/g, '\\"')+'"';
                    // };
                    opes[k] =
                      '"' +
                      val.trim('"').trim("'").trim("`").replace(/\"/g, '\\"') +
                      '"';
                    return;
                  });
                  var inline = [];
                  for (var k in opes) {
                    //  opes[k] = ('' + opes[k]);
                    //代码没问题 但是ES会不适应高并发 会发生并发错误容易发生数据不一致
                    // if(!opes[k].match(/^[\"\']/g) && !!opes[k].match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/
                    //     opes[k] = opes[k].replace(/[\`a-zA-Z0-9_\.]+/g,function(v){return +(v)==v?v.trim('`'):'ctx._source'+v.trim('`').trim('"').trim("'")+''});
                    // }
                    // else
                    //  opes[k] = '"'+opes[k].trim('"').trim('\'').trim('`').replace(/\"/g, '\\"')+'"';111
                    inline.push("ctx._source." + k + "=" + opes[k]);
                  }
                  es.body["script"]["inline"] = inline.join(";");
                  console.log(8431, opes, inline);
                }
                break;
              case "select":
                {
                  params._method = "sql";
                  //保证两次返回的值一定
                  const params2 = V.merge({}, params);
                  sb.append(
                    `select ${
                      V.isValid(__.getValue(params["_distinct"]))
                        ? "distinct "
                        : ""
                    }`,
                  );
                  const length = sb.toString().length;
                  if (V.isValid(__.getValue(params["_columns"]))) {
                    //对columns进行特殊处理
                    var columns = __.getValue(params["_columns"]);
                    delete params["_columns"];
                    columns.split(",").forEach(
                      (col) =>
                        (params[col.replace(/^[$_?]|\s/g, "")] = {
                          value: true,
                        }),
                    );
                  }
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("+") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    ) {
                      const v = __.getValue(params[k]);
                      if (undefined === v) continue;

                      k = k.replace(/;/g, "_");
                      if (!!v.match(/[\.\?\(\)\+\-\*/]/))
                        sb.append(`${v} as ${k}`).append(",");
                      else if (k.match(/\./g))
                        sb.append(k)
                          .append(("" + v).eq("true") ? "" : ` as ${v} `)
                          .append(",");
                      else
                        sb.append(`"${k}"`)
                          .append(("" + v).eq("true") ? "" : ` as ${v} `)
                          .append(",");
                    }
                  }
                  if (length == sb.toString().length) {
                    if (__.isStrict) throw new Error("不能显示所有列");
                    else sb.append("*");
                  } else sb.append(sb.clear().trim(","));
                  params["_lock"] &&
                    sb.append(
                      ` ${
                        true === params["_lock"]
                          ? "for update"
                          : params["_lock"]
                      } `,
                    );
                  const body = ` from ${__.getTable(database, table, params)} `;
                  sb.append(body).append(`where ${that.getWhere(params)};`);
                  params["_count"] &&
                    sb
                      .append(
                        `select count(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }ID) as count ${body} where `,
                      )
                      .append(that.getWhere(params2, true))
                      .append(";");
                  V.merge(params, params2, true);
                  if (table.match(/[\|&]/g)) {
                    //| union & union all
                    const sql = sb.clear().trim(";");
                    const ope = table.match(/\|/g) ? "|" : "&";
                    sb.append(
                      table
                        .split(ope)
                        .map(function (v) {
                          return sql.replace(/\{tablename\}/g, v);
                        })
                        .join(ope.eq("|") ? " union " : " union all "),
                    );
                  }
                  es.body = { query: sb.clear() };
                  params["_size"] &&
                    ((es.body.fetch_size = +(
                      params["_size"].value || params["_size"]
                    )),
                    delete params["_size"]);
                  console.warn(
                    "ES查询数据大于1000时，请注意设置max_result_window最大值!",
                  );
                  sb.append("query");
                }
                break;
              case "count":
                {
                  params._method = "sql";

                  sb.append(`select `).append(
                    (paraname["_group"]
                      ? __.getValue(paraname["_group"]) + ","
                      : "") || "",
                  );
                  const length = sb.toString().length;

                  var i = 1;
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sb.append(
                        `count(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }`,
                      )
                        .append(
                          k.match(/[\.,\(]/g)
                            ? k
                            : (__.getValue(params[k]) + "").match(/[\.\(,]/g)
                              ? __.getValue(params[k])
                              : `"${k}"`,
                        )
                        .append(
                          `) as "${k.match(/\./g) ? "count" + i++ : k}",`,
                        );
                  }

                  if (length == sb.toString().length)
                    throw new Error("count命令未设置统计列 例如 column1:true");
                  else sb.append(sb.clear().trim(","));

                  const body = __.getTable(database, table, params);
                  const where = that.getWhere(params);
                  sb.append(` from ${body} where `).append(where);

                  es.body = { query: sb.clear() };
                  sb.append("query");
                  //todo 优化SQL
                }
                break;
              case "sum":
                {
                  params._method = "sql";
                  sb.append(`select `).append(
                    (paraname["_group"]
                      ? __.getValue(paraname["_group"]) + ","
                      : "") || "",
                  );
                  const length = sb.toString().length;
                  var i = 1;
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sb.append(
                        `sum(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }`,
                      )
                        .append(
                          k.match(/[\.,\(]/g)
                            ? k
                            : (__.getValue(params[k]) + "").match(/[\.\(,]/g)
                              ? __.getValue(params[k])
                              : `"${k}"`,
                        )
                        .append(
                          `) as "${k.match(/\./g) ? "count" + i++ : k}",`,
                        );
                  }
                  if (length == sb.toString().length)
                    throw new Error("sum命令未设置统计列 例如 column1:true");
                  else sb.append(sb.clear().trim(","));

                  const body = __.getTable(database, table, params);
                  const where = that.getWhere(params);
                  sb.append(` from ${body} where `).append(where);
                  //todo 优化SQL

                  es.body = { query: sb.clear() };
                  sb.append("query");
                }
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        case 2:
          /**
           * 库名/操作
           * create 新建库
           * drop 删除库
           */
          {
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              method = cmds[1];
            if (!database.length) throw new Error("请输入库名!");
            switch (method.toLowerCase()) {
              case "create":
              case "drop":
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        default:
          throw new Error(
            "无法处理命令类型:" +
              command +
              "!请按照[库].表[.字段|索引].操作 方式设置命令!",
          );
      }
      cmd.command = sb.clear();
      params["es"] = es;
      if ("true".eq(__.getValue(paraname["_debug"])))
        console.log("es", cmd.command, cmd.params);
    } finally {
      params.es = es;
      sb = null;
    }
  }
};

export default {
  EMBESConverter,
};
const pri = V.pris();
